<template>
  <div class="page_">
    <div class="topBanner">
      <div>区块链确权</div>
      <div>确权获得版权确权证书才能保障作者的基本权利</div>
      <div>龙源版权确权平台努力保护您的作品，让您的创作获得应有的回报</div>
    </div>
    <div class="phoneContainer">
      <div class="left_">
        <div class="title_">
          区块链确权证书<br />与北京市版权局双证书
        </div>
        <div class="content_">
          <div>
            为您的作品获得证书才能根本上证明创作的归属
          </div>
          <div>
            用科技手段和法律手段，同时进行确权，让作品在创作出后马上可以获得第一时间的时间戳，让您的作品不再可能有其他人冒领或让创作归属存在争议。<br /><br />政府颁发的版权证书，也是国家司法部门承认程度最高的创作凭证
          </div>
        </div>
      </div>
      <div class="right_">
        <img src="../../assets/images/staticPage/copyrightConfirmationRegistration/phone.png" alt="">
      </div>
    </div>
    <div class="bgBanner">
      <div class="title">
        出版前，保护您的作品
      </div>
      <div class="content_">
        在作品没有出版/发布前，在面对潜在出版方沟通的时候，是作品泄露的安全重灾区。用传统的微信或邮箱发送，容易被非法传播；甚至传统的邮递，因为无法证明邮递内容；<br /><br />
        使用龙源版权确权平台，只有您认可的出版发才有资格阅读您的未出版、未发表内容；且提供了限时链接失效的机制；最大程度的保护了您的未发表内容不会非法传播。
      </div>
    </div>
    <div class="computerContainer">
      <div class="left_">
        <div class="title_">
          精确授权，随时了解情况
        </div>
        <div class="content">
          <div>简化授权和定价</div>
          <div>我们帮您简化了基本的授权方式；既不过度授权，也没有让授权太窄降低了出版发对您作品因为授权不足无法出版的。</div>
        </div>
        <div class="content">
          <div>轻松为您的作品在不同的领域的定价</div>
          <div>我们帮助您可以设定面对不同出版方的定价，授权时间、和限时独家性。让您的作品可以同时、最小冲突的授权给不同的版权单位，最大化您的影响和收益。</div>
        </div>
        <div class="content">
          <div>即时收益查询和快速提现</div>
          <div>您可以随时登陆您的账户，按作品查询版权收益，并24小时内提现到支付宝或微信。<br>当然，也可以根据版权授权情况随时调整作品的授权条件和定价。</div>
        </div>
      </div>
      <div class="right_">
        <img src="../../assets/images/staticPage/copyrightConfirmationRegistration/rightImg.png" alt="">
      </div>
    </div>

    <div class="bottomContainer">
      <div class="item">
        <img src="../../assets/images/staticPage/copyrightConfirmationRegistration/logo1.png" alt="">
        <div class="title_">
          专职版权
        </div>
        <div class="content">
          龙源版权确权平台版权专家通过监控，内部核查和外部测试来保护你的个人信息。
          作为行业领导者，我们不断与国家版权局、各地版权局采取维权和盗版打击措施。我们提高了不法分子盗用内容的门槛。<br /><br />如果您认为您的作品有侵权行为或安全相关问题<br />
          <span style="text-decoration:underline">请今天就联系我们</span>
        </div>
      </div>
      <div class="item">
        <img src="../../assets/images/staticPage/copyrightConfirmationRegistration/logo2.png" alt="">
        <div class="title_">
          了解确权 版权保护
        </div>
        <div class="content">
          在收权您的作品时，会遇到不同法律权利的赋予、独家性、时限等差异，为了保障您的权益，您可以可以进一步了解。<br /><br /><br />

          <p>您希望了解：</p>
          <span>
            各类版权权利说明<br />
            区块链确权和著作权证书<br />
            不同行业客户为什么需要这些权利？<br />
            通常不要授权哪些权利？<br />
            是不是必须要出版发表了才需要进行版权登记？<br />
            我已经发现有人对我侵权了，可以怎么办
          </span>
        </div>
      </div>
    </div>
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>

<script>
import { reactive } from "vue";
import marketingPageFooter from '@/components/marketingPageFooter.vue'
// import { useRoute, useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "copyrightConfirmationRegistration",
  components: {
    marketingPageFooter
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    // const router = useRouter();
    // const store = useStore();
    let pageData = reactive({

    })
    return {
      pageData
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {
  display: flex;
  flex-direction: column;
  align-items: center;

  .bottomContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin:161px 0 80px;
    .item {
      width: 465px;
      height: 402px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1), inset 0px 8px 0px 0px #008AEA;
      padding: 30px;
      box-sizing: border-box;
      margin-left: 30px;

      .content {
        font-size: 14px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        line-height: 20px;
        span{
          color: #008AEA;
          font-weight: 500;
        }
        p{
          font-weight: 700;
        }
      }

      img {
        width: 80px;
      }

      .title_ {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        margin: 16px 0 8px;
        font-weight: 700;
      }
    }

    .item:first-of-type {
      margin: 0;
    }
  }

  .computerContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .right_ {
      width: 662px;
      margin-left: 13px;

      img {
        width: 100%;
      }
    }

    .left_ {
      width: 445px;

      .title_ {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        margin-bottom: 24px;
        font-weight: 800;
      }

      .content {
        margin-bottom: 24px;

        div {
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          // letter-spacing: .08em;
        }

        div:nth-of-type(1) {
          margin-bottom: 4px;
          font-weight: 800;
        }

        div:nth-of-type(2) {
          line-height: 24px;
        }
      }
    }
  }

  .bgBanner {
    width: 100%;
    height: 760px;
    background: url('../../assets/images/staticPage/copyrightConfirmationRegistration/banner.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: relative;
    top: -110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content_ {
      width: 720px;
      font-size: 18px;
      font-family: AlibabaPuHuiTiR;
      color: #FFFFFF;
      line-height: 24px;
      margin-right: 200px;
    }

    .title {
      width: 720px;
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #FFFFFF;
      font-weight: 700;
      margin-bottom: 24px;
      margin-right: 200px;
    }
  }

  .phoneContainer {
    width: 1140px;
    height: 628px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: -55px;
    z-index: 2;

    .left_ {
      width: 640px;
      margin-right: 74px;

      .title_ {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        margin-bottom: 24px;
        font-weight: 700;
      }

      .content_ {
        div:nth-of-type(1) {
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          font-weight: 500;
          margin-bottom: 4px;
        }

        div:nth-of-type(2) {
          font-size: 18px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
        }
      }
    }

    .right_ {
      width: 261px;

      img {
        width: 100%;
      }
    }
  }

  .topBanner {
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #008AEA;

    div {
      width: 100%;
      text-align: center;
      font-family: AlibabaPuHuiTiB;
      color: #FFFFFF;
    }

    div:nth-of-type(1) {
      font-size: 24px;
    }

    div:nth-of-type(2) {
      font-size: 40px;
      line-height: 48px;
      margin: 8px 0;
    }

    div:nth-of-type(3) {
      font-size: 18px;

    }
  }
}
</style>
